var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPostgres(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "transparent"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 24,
    height: 24,
    rx: 4,
    fill: "#387eff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.288 19.9544C23.3223 20.3598 23.1872 19.6943 23.1872 19.6943C25.2627 16.6147 26.1303 12.7055 25.3815 11.7488C23.339 9.139 19.8031 10.3733 19.7441 10.4053L19.7251 10.4087C19.3368 10.3281 18.9022 10.2801 18.4137 10.2721C17.5242 10.2575 16.8496 10.5053 16.3376 10.8935C16.3376 10.8935 10.03 8.29504 10.3234 14.1616C10.3858 15.4096 12.1122 23.605 14.1714 21.1296C14.9241 20.2244 15.6512 19.4591 15.6512 19.4591C16.0124 19.699 16.4448 19.8214 16.8981 19.7775L16.9333 19.7476C16.9224 19.8599 16.9274 19.9699 16.9475 20.1C16.417 20.6927 16.5729 20.7968 15.5124 21.015C14.4394 21.2362 15.0697 21.6299 15.4813 21.7328C15.9802 21.8576 17.1346 22.0343 17.9145 20.9425L17.8834 21.0671C18.0913 21.2335 18.2372 22.1499 18.2127 22.9806C18.1883 23.8114 18.172 24.3817 18.3357 24.8272C18.4995 25.2727 18.6627 26.275 20.0568 25.9763C21.2217 25.7267 21.8253 25.0798 21.9093 24.0008C21.9689 23.2336 22.1037 23.347 22.1122 22.6612L22.2204 22.3365C22.3451 21.2966 22.2402 20.9611 22.9579 21.1172L23.1323 21.1325C23.6605 21.1565 24.3518 21.0475 24.7576 20.8589C25.6313 20.4535 26.1494 19.7765 25.288 19.9544H25.288Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9995 20.5508C17.9454 22.4857 18.0131 24.4342 18.2024 24.9077C18.3919 25.3813 18.7973 26.3023 20.1915 26.0037C21.3562 25.754 21.78 25.2707 21.9639 24.2041C22.0994 23.4194 22.3605 21.2399 22.394 20.7934",
    stroke: "#387eff",
    strokeWidth: 0.487107,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3282 10.852C16.3282 10.852 10.0163 8.27224 10.3097 14.1388C10.3721 15.3868 12.0987 23.5824 14.1578 21.1069C14.9103 20.2017 15.5908 19.4917 15.5908 19.4917",
    stroke: "#387eff",
    strokeWidth: 0.487107,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7377 10.3802C19.5192 10.4487 23.2488 9.01685 25.3683 11.7252C26.117 12.6819 25.2494 16.5911 23.174 19.6708",
    stroke: "#387eff",
    strokeWidth: 0.487107,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1736 19.6711C23.1736 19.6711 23.3089 20.3368 25.2746 19.931C26.1359 19.7532 25.6175 20.4302 24.744 20.8359C24.0272 21.1686 22.4199 21.2539 22.3937 20.7941C22.3261 19.6079 23.2396 19.9683 23.1736 19.6711ZM23.1736 19.6711C23.114 19.4034 22.7056 19.1407 22.4353 18.4855C22.1994 17.9137 19.1999 13.5286 23.2672 14.1798C23.4162 14.149 22.2064 10.3111 18.3999 10.2487C14.5944 10.1863 14.7192 14.9287 14.7192 14.9287",
    stroke: "#387eff",
    strokeWidth: 0.487107,
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9336 20.0771C16.403 20.6697 16.5591 20.7738 15.4985 20.9921C14.4255 21.2133 15.0559 21.6069 15.4674 21.7098C15.9663 21.8347 17.1207 22.0114 17.9006 20.9193C18.1381 20.5868 17.8992 20.0562 17.5729 19.921C17.4153 19.8557 17.2045 19.7739 16.9336 20.0771Z",
    stroke: "#387eff",
    strokeWidth: 0.487107,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8995 20.0653C16.846 19.7169 17.014 19.3022 17.194 18.8171C17.4645 18.0892 18.0886 17.3613 17.5893 15.0524C17.2172 13.3319 14.7212 14.6943 14.7196 14.9276C14.7181 15.1608 14.8325 16.1101 14.6779 17.2155C14.4762 18.658 15.5958 19.878 16.885 19.7532",
    stroke: "#387eff",
    strokeWidth: 0.487107,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3053 14.8925C16.294 14.9722 16.4511 15.1848 16.656 15.2132C16.8605 15.2418 17.0356 15.0756 17.0467 14.996C17.0578 14.9163 16.9009 14.8286 16.6959 14.8C16.4913 14.7715 16.3161 14.813 16.3053 14.8925H16.3053Z",
    fill: "#387eff",
    stroke: "#387eff",
    strokeWidth: 0.162368
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5352 14.7304C22.5463 14.8101 22.3894 15.0227 22.1845 15.0511C21.9798 15.0796 21.8047 14.9135 21.7935 14.8339C21.7827 14.7542 21.9396 14.6664 22.1444 14.6379C22.3491 14.6094 22.5241 14.6509 22.5352 14.7304V14.7304Z",
    fill: "#387eff",
    stroke: "#387eff",
    strokeWidth: 0.0811838
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2669 14.1797C23.3007 14.8047 23.1323 15.2304 23.1111 15.8957C23.0797 16.8628 23.5722 17.9697 22.8301 19.078",
    stroke: "#387eff",
    strokeWidth: 0.487107,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPostgres);
export default __webpack_public_path__ + "static/media/icon-postgres.3f176ae58fa2c6c226a7a144830a2e02.svg";
export { ForwardRef as ReactComponent };